export const COPY_SUCCESS = "Password successfully copied to clipboard"
export const COPY_Fail = "Please select the below checkboxes and genarate password"